var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-header-group-cell-label"},[_c('div',{ref:"agLabel",staticClass:"ag-header-group-text"},[_vm._v("\n    "+_vm._s(_vm.params.label)+"\n    "),_c('span',{staticClass:"sr-only"},[_vm._v(" Column Header")])])])}
var staticRenderFns = []

export { render, staticRenderFns }